import moment from "moment-timezone";
import { CustomHeader } from "tap/components/AGGrid/cell-renderers/CustomHeader.jsx";

export const id = {
  field: "id",
  headerName: "ID",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "id",
    page: "pmxDeliveries",
  },
  minWidth: 100,
};

export const action = {
  field: "action",
  headerName: "Action",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "action",
    page: "pmxDeliveries",
  },
  minWidth: 100,
};

export const status = {
  field: "status",
  headerName: "Status",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "status",
    page: "pmxDeliveries",
  },
  minWidth: 100,
};

export const pmxSkuId = {
  field: "pmxSku.pmxSkuId",
  headerName: "SKU ID",
  minWidth: 150,
};

export const productId = {
  field: "pmxSku.pmxProduct.pmxProductId",
  headerName: "Product ID",
  minWidth: 150,
};

export const releaseId = {
  field: "pmxSku.pmxProduct.pmxRelease.pmxReleaseId",
  headerName: "Release ID",
  minWidth: 100,
};

export const name = {
  field: "pmxSku.pmxProduct.pmxRelease.releaseName",
  headerName: "Name",
  minWidth: 150,
};

export const type = {
  field: "pmxSku.pmxProduct.pmxRelease.releaseType",
  headerName: "Type",
  minWidth: 150,
};

export const territory = {
  field: "pmxSku.skuKeyDates[0].territory",
  headerName: "Territory",
  minWidth: 150,
};

export const releaseDate = {
  field: "pmxSku.releaseDate",
  headerName: "Release Date",
  valueFormatter: ({ value }) =>
    value ? moment(value).format("MM/DD/YYYY") : "",
  minWidth: 100,
};

export const error = {
  field: "errorMsg",
  headerName: "Error",
  minWidth: 150,
};

export const created = {
  field: "createdAt",
  headerName: "Created",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "createdAt",
    page: "pmxDeliveries",
  },
  minWidth: 100,
};

export const modified = {
  field: "modifiedAt",
  headerName: "Modified",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "modifiedAt",
    page: "pmxDeliveries",
  },
  minWidth: 225,
};
